( function( global, $ ) {

    var prevArrow = '<button class="slider__arrow slider__prev" type="button" aria-label="Previous"></button>';
    var nextArrow = '<button class="slider__arrow slider__next" type="button" aria-label="Next"></button>';

    $('[gr-carousel]').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        responsive:
        [
            {
                breakpoint: parseInt(window.groots.sassBreakpoints['md'], 10),
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: parseInt(window.groots.sassBreakpoints['xs'], 10),
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    // Helper to pause and play autoplay of the slider when we hit a video
    function handleAutoplay($video) {
        if ($video.length) {
            setTimeout(function() {
                $carouselHero.slick('slickPause');
            }, 1);
        } else {
            setTimeout(function() {
                $carouselHero.slick('slickPlay');
            }, 1);
        }
    }

    // Helper to pause and play video on slide change
    function handleVideos($video) {
        if (!$video.length) {
            return;
        }

        var videos = global.grVideoYoutube.instances;
        for (var key in videos) {
            var instance = videos[key];
            if (instance.selector === $video[0]) {
                if (!instance.ready) return;
                instance.replay();
            } else {
                if (!instance.ready) return;
                instance.pause();
            }
        }
    }

    var $carouselHero = $('[gr-carousel-hero]');

    $carouselHero.on('init', function(event, slick) {
        var $currentSlide = slick.$slides.eq(0);
        var $video = $currentSlide.find('[gr-video-youtube]');
        handleAutoplay($video);
    });

    $carouselHero.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        var $nextSlide = slick.$slides.eq(nextSlide);
        var $video = $nextSlide.find('[gr-video-youtube]');
        handleVideos($video);
        handleAutoplay($video);
    });

    $carouselHero.slick({
        autoplay: true,
        autoplaySpeed: 4000, // MS
        pauseOnHover: true,
        infinite: true,
        adaptiveHeight: true,
        speed: 500, // MS
        fade: true,
        cssEase: 'linear',
        prevArrow: prevArrow,
        nextArrow: nextArrow
    });

}( window.groots, jQuery, require('slick-carousel') ));
